var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-row__wrapper"},[(_vm.$slots.value)?_c('div',{staticClass:"gl-row__value",class:{
      'gl-row__value--ellipsis': _vm.ellipsis,
    }},[_vm._t("value")],2):_c('div',{staticClass:"gl-row__value",class:{
      'gl-row__value--ellipsis': _vm.ellipsis,
    }},[_vm._v(" "+_vm._s(_vm.value || '–')+" ")]),(_vm.iconName)?_c('gl-icon',{attrs:{"height":_vm.iconHeight,"link":_vm.isIconLink,"name":_vm.iconName,"width":_vm.iconWidth}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }